const localStorageRef = (): Storage | undefined => {
  try {
    return globalThis.localStorage
  } catch {
    return undefined
  }
}

export const get = (key: string): string | null => {
  const storage = localStorageRef()
  if (storage == null) {
    return null
  }
  return storage.getItem(key)
}

export const store = (key: string, value: string): void => {
  const storage = localStorageRef()
  if (storage == null) {
    return
  }
  storage.setItem(key, value)
}

export const remove = (key: string): void => {
  const storage = localStorageRef()
  if (storage == null) {
    return
  }
  storage.removeItem(key)
}

export const LOCAL_STORAGE_KEYS = {
  MIMIR_MODEL_TYPE_PREFERENCE: 'mimirModelTypePreference',
  SIDE_NAVIGATION_STATE: 'sideNavigationState',
  COPILOT_CHAT_ID: (userId: string, clientId: number, surface = 'drawer'): string =>
    `copilotChatId_${userId}_${clientId}_${surface}`,
  /**
   * Per-chat source picker selection (entities / cirrus / knowledge).
   * Written on send only; scoped by surface so drawer and Alvie AI Pro do not clobber each other.
   */
  COPILOT_SOURCE_SELECTION: (clientId: number, chatId: string, surface: string): string =>
    `copilotSourceSelection:v1:${clientId}:${surface}:chat:${chatId}`,
  /** Per-surface last-used source picker selection — updated on picker click; seeds new chats. */
  COPILOT_LAST_SOURCE_SELECTION: (clientId: number, surface: string): string =>
    `copilotLastSourceSelection:v1:${clientId}:${surface}`,
  /** Dev-only per-surface agent override (see `IS_AGENT_SWITCHER_ENABLED`). */
  COPILOT_AGENT_NAME: (surface: string): string => `copilotAgentName:${surface}`,
  CHANNEL_GROUPING_METRIC_SELECTION: 'channelGroupingMetricSelection',
  REPORTING_BASE_HOME_PAGE_SUMMARY_CARDS_METRIC_SELECTION: 'reportingBaseHomePageSummaryCardsMetricSelection',
  REPORTING_BASE_HOME_PAGE_CONVERSION_EVENTS_SELECTION: (reportId: string) =>
    `reportingBaseHomePageConversionEventsSelection_${reportId}`,
  CHANNEL_GROUPING_HOME_PAGE_SUMMARY_CARDS_METRIC_SELECTION: 'channelGroupingHomePageSummaryCardsMetricSelection',
  SELECTED_REPORT_ID_FOR_CLIENT_HOMEPAGE: (clientId: number): string => `selectedReportIdForClientHomepage_${clientId}`,
  SELECTED_REPORT_ID_FOR_CREATIVE_REPORTING: (clientId: number): string =>
    `selectedReportIdForCreativeReporting_${clientId}`,
  CREATIVE_REPORTING_HOME_PAGE_CONVERSION_EVENTS_SELECTION: (reportId: string) =>
    `creativeReportingHomePageConversionEventsSelection_${reportId}`,
  HOME_PAGE_COMPARISON_PERIOD_SELECTION: (reportId: string) => `homePageComparisonPeriodSelection_${reportId}`,
  HOME_PAGE_CUSTOM_COMPARISON_RANGE: (reportId: string) => `homePageCustomComparisonRange_${reportId}`,
  REPORTING_BASE_HOME_PAGE_BUDGET_MODE: (reportId: string) => `reportingBaseHomePageBudgetMode_${reportId}`,
  SHOW_DASHBOARD_CREATED_SUCCESSFULLY_HELPER_DIALOG: 'showDashboardCreatedSuccessfullyHelperDialog',
  SHOW_DASHBOARD_CREATE_LEAVE_ALVIE_DIALOG: 'showDashboardCreateLeaveAlvieDialog',
  COLOUR_THEME_PREFERENCE: 'colourThemePreference:v1'
}
